<script setup>
</script>

<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<style>
</style>
